// import React from "react";
// import { useTranslation } from "react-i18next";
// import { Link, useParams } from "react-router-dom";
// import "./Blog.scss";

// const Blog = () => {
//   const { t } = useTranslation();
//   const { lang } = useParams();

//   const posts = [
//     {
//       id: 1,
//       image: "/Images/bg1.jpg",
//       title: t("blog.posts.0.title"),
//       date: t("blog.posts.0.date"),
//       preview: t("blog.posts.0.preview"),
//     },
//     {
//       id: 2,
//       image: "/Images/bg3.jpg",
//       title: t("blog.posts.1.title"),
//       date: t("blog.posts.1.date"),
//       preview: t("blog.posts.1.preview"),
//     },
//     {
//       id: 3,
//       image: "/Images/puffin.jpg",
//       title: t("blog.posts.2.title"),
//       date: t("blog.posts.2.date"),
//       preview: t("blog.posts.2.preview"),
//     },
//   ];

//   return (
//     <div
//       className="container"
//       style={{ backgroundImage: 'url("/Images/ice.jpg")' }}
//     >
//       <main className="blog">
//         <header className="blog__header">
//           <h1 className="blog__title">{t("blog.title")}</h1>
//           <p className="blog__subtitle">{t("blog.subtitle")}</p>
//         </header>

//         <section className="blog__list">
//           {posts.map((post) => (
//             <Link
//               key={post.id}
//               to={`/${lang}/blog/${post.id}`}
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               <article className="blog-card">
//                 <div className="blog-card__image-wrapper">
//                   <img
//                     src={post.image}
//                     alt={post.title}
//                     className="blog-card__image"
//                     loading="lazy"
//                   />
//                 </div>

//                 <div className="blog-card__content">
//                   <span className="blog-card__date">{post.date}</span>
//                   <h2 className="blog-card__title">{post.title}</h2>
//                   <p className="blog-card__text">{post.preview}</p>
//                 </div>
//               </article>
//             </Link>
//           ))}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Blog;


import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import "./Blog.scss";

const Blog = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const posts = [
    {
      id: 1,
      image: "/Images/blog2.jpg",
      title: t("blog.posts.0.title"),
      date: t("blog.posts.0.date"),
      preview: t("blog.posts.0.preview"),
    },
    {
      id: 2,
      image: "/Images/vs.jpg",
      title: t("blog.posts.1.title"),
      date: t("blog.posts.1.date"),
      preview: t("blog.posts.1.preview"),
    },
    {
      id: 3,
      image: "/Images/article3.jpg",
      title: t("blog.posts.2.title"),
      date: t("blog.posts.2.date"),
      preview: t("blog.posts.2.preview"),
    },
  ];

  return (
    <main className="blog">
      <div className="blog__container">
        <header className="blog__header">
          <h1 className="blog__title">{t("blog.title")}</h1>
          <p className="blog__subtitle">{t("blog.subtitle")}</p>
        </header>

        <section className="blog__list">
          {posts.map((post) => (
            <article className="blog-card" key={post.id}>
              <div className="blog-card__image-wrapper">
                <img
                  src={post.image}
                  alt={post.title}
                  className="blog-card__image"
                  loading="lazy"
                />
              </div>

              <div className="blog-card__content">
                <span className="blog-card__date">{post.date}</span>
                <h2 className="blog-card__title">{post.title}</h2>
                <p className="blog-card__text">{post.preview}</p>

                <Link
                  to={`/${lang}/blog/${post.id}`}
                  className="blog-card__readmore"
                >
                  {t("blog.readMore")} →
                </Link>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
};

export default Blog;